<template>
  <div class="protocol-attachments-containet">
    <div class="list-group list-group-bordered mb-3" v-if="files && files.length">
      <div class="list-group-header d-flex align-items-center"
           :class="{ 'justify-content-between': extraSmall || small, 'flex-column': extraSmall || small}">
        <span :class="{ 'mb-2': extraSmall || small }">{{ files.length }} {{
            files.length === 1 ? 'Archivo' : 'Archivos'
                                       }} agregados</span>
        <div :class="{ 'ml-auto': !extraSmall && !small }" v-if="!readonly">
          <div class="d-inline-block">
            <button type="button"
                    class="btn btn-light" title="Add files"
                    data-toggle="modal"
                    data-target="#attachments-modal"
                    @click="$emit('add-file')">
              <i class="fas fa-paperclip mr-2"></i> Agregar anexo
            </button>
          </div>
        </div>
      </div>
      
      <div class="list-group-item" v-for="file in files">
        <div class="list-group-item-figure">
          <a href="#" class="tile tile-circle bg-red">
            <i class="fas fa-file-pdf"></i>
          </a>
        </div>
        <div class="list-group-item-body">
          <a :href="`/${file.path}`" :download="file.name" class="d-block">{{ file.name }}</a>
          <small v-if="file.created_at" class="text-sm text-muted">{{ fileDate(file) }}</small>
        </div>
        
        <div class="list-group-item-figure align-items-start" v-if="!readonly">
          <div class="dropdown">
            <button class="btn btn-sm btn-icon btn-light"
                    data-toggle="dropdown"><i
              class="fa fa-fw fa-ellipsis-v"></i></button>
            <div class="dropdown-menu dropdown-menu-right">
              <div class="dropdown-arrow mr-n1"></div>
              <a :href="`/${file.path}`"
                 type="button"
                 target="_blank"
                 class="dropdown-item"
                 ref="btn-view-file">Ver archivo
              </a>
              
              <div class="dropdown-divider"></div>
              
              <button type="button"
                      class="dropdown-item"
                      ref="btn-remove-file"
                      @click="showConfirmDeleteFile(file)">Eliminar archivo
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div v-else>
      <div class="alert alert-info has-icon d-flex align-items-center"
           role="alert">
        <div class="alert-icon">
          <span class="oi oi-info"></span>
        </div>
        No se han agregado anexos
        <a href="#attachments-modal"
           class="alert-link ml-1"
           data-toggle="modal">De click aquí para agregar.</a>
      </div>
    </div>
    
    <portal to="modals">
      <file-modal id="attachments-modal"
                  multiple
                  title="Adjuntar anexos"
                  :save-files-function="saveFilesFunction"
                  ref="attachments-modal"></file-modal>
      
      <ok-cancel-dialog id="delete-attachment-modal"
                        :title="title"
                        :content="content"
                        ok-button-text="Eliminar"
                        ok-button-type="danger"
                        @ok-button-pressed="deleteAttachmentConfirmed"
                        @cancel-button-pressed="removeFileDialogCancelled"
                        ref="delete-attachment-modal"></ok-cancel-dialog>
    </portal>
  </div>
</template>
<script>
  import FileModal from '../ui/FileModal'
  import OkCancelDialog from '../ui/OkCancelDialog'
  import moment from 'moment'
  
  export default {
    name: 'FileList',
    components: {
      FileModal,
      OkCancelDialog,
    },
    props: {
      files: {
        type: Array,
        default: () => ([]),
      },
      model: {
        type: Object,
      },
      saveFilesFunction: {
        type: Function,
      },
      readonly: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: 'Eliminar anexo de protocolo',
      },
      content: {
        type: String,
        default: '<p>¿Está seguro de eliminar el anexo del protocolo?</p>',
      },
    },
    data: () => ({
      selectedFile: null,
    }),
    methods: {
      showConfirmDeleteFile (file) {
        this.selectedFile = file
        
        $(this.$refs['delete-attachment-modal'].$el).modal({
          keyboard: false,
          backdrop: 'static',
        })
      },
      removeFileDialogCancelled () {
        this.selectedFile = null
      },
      deleteAttachmentConfirmed () {
        this.$refs['delete-attachment-modal'].sending = true
        
        this.$emit('delete-file', this.selectedFile, () => {
          this.$refs['delete-attachment-modal'].sending = false
          this.selectedFile                             = null
          
          $(this.$refs['delete-attachment-modal'].$el).modal('hide')
        })
      },
      fileDate(file){
        return moment(file.created_at).format('DD/MM/YYYY hh:mm:ss')
      }
    },
    computed: {
      extraSmall () {
        return this.$mq === 'xs'
      },
      small () {
        return this.$mq === 'sm'
      },
    },
  }
</script>
